export default function CTASection() {
  return (
    <section id="contatti" className="py-16 sm:py-20 lg:py-32 bg-gradient-to-br from-[#F8F9FA] via-white to-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-6 sm:mb-8">
            Inizia la Valorizzazione del Tuo Patrimonio
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#1C1C1C]/70 mb-8 sm:mb-10 lg:mb-12 leading-relaxed px-4">
            Richiedi la tua pre-analisi gratuita e scopri il potenziale nascosto della tua azienda. 
            Un'opportunità per comprendere il valore reale dei tuoi asset intangibili.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-8 sm:mb-10 lg:mb-12 px-4">
            <a
              href="mailto:info@brandcapital.it?subject=Richiesta Pre-Analisi Gratuita"
              className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-[#E879F9] text-white rounded-md text-base sm:text-lg font-semibold hover:bg-[#E879F9]/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Richiedi Pre-Analisi Gratuita
            </a>
            <a
              href="/contatti"
              className="w-full sm:w-auto px-8 sm:px-10 py-3 sm:py-4 bg-[#22C55E] text-white rounded-md text-base sm:text-lg font-semibold hover:bg-[#22C55E]/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Prenota una consulenza
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 text-left">
            <div className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-white rounded-lg shadow-md">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#22C55E]/10 rounded-lg flex-shrink-0">
                <i className="ri-mail-line text-xl sm:text-2xl text-[#22C55E]"></i>
              </div>
              <div>
                <h4 className="text-sm sm:text-base font-semibold text-[#0B1F3B] mb-1">Email</h4>
                <p className="text-xs sm:text-sm text-[#1C1C1C]/70">info@brandcapital.it</p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-white rounded-lg shadow-md">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#22C55E]/10 rounded-lg flex-shrink-0">
                <i className="ri-phone-line text-xl sm:text-2xl text-[#22C55E]"></i>
              </div>
              <div>
                <h4 className="text-sm sm:text-base font-semibold text-[#0B1F3B] mb-1">Telefono</h4>
                <p className="text-xs sm:text-sm text-[#1C1C1C]/70">327 690 8748</p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-white rounded-lg shadow-md sm:col-span-2 lg:col-span-1">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#22C55E]/10 rounded-lg flex-shrink-0">
                <i className="ri-time-line text-xl sm:text-2xl text-[#22C55E]"></i>
              </div>
              <div>
                <h4 className="text-sm sm:text-base font-semibold text-[#0B1F3B] mb-1">Risposta</h4>
                <p className="text-xs sm:text-sm text-[#1C1C1C]/70">Entro 24 ore</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
